export default {"src":"/blog/_next/static/media/linkedin.47acdfb3.svg","height":15,"width":14};